class Timer {
  constructor(dateString) {
    this.endDate = this.convertDateFormat(dateString);
    this.timerInterval = null;
  }

  convertDateFormat(dateString) {
    const parts = dateString.split("-");
    const year = parseInt(parts[2], 10);
    const month = parseInt(parts[1], 10) - 1; // Month is zero-based
    const day = parseInt(parts[0], 10);

    const date = new Date(year, month, day, 0, 0, 0);
    return date;
  }

  start() {
    this.timerInterval = setInterval(() => {
      const currentTime = new Date().getTime();
      const timeRemaining = this.endDate - currentTime;

      // Check if the timer has reached or passed the end date
      if (timeRemaining <= 0) {
        this.stop();
        return;
      }

      const remainingTime = this.calculateRemainingTime(timeRemaining);
      this.updateDisplay(remainingTime);
    }, 1000); // Update every second
  }

  stop() {
    clearInterval(this.timerInterval);
    dateElement.style.display = "none";
  }

  calculateRemainingTime(timeRemaining) {
    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeRemaining / (1000 * 60)) % 60);
    const seconds = Math.floor((timeRemaining / 1000) % 60);

    return { days, hours, minutes, seconds };
  }

  updateDisplay(remainingTime) {
    document.querySelector(".countdown__days").textContent = remainingTime.days;
    document.querySelector(".countdown__hours").textContent =
      remainingTime.hours;
    document.querySelector(".countdown__minutes").textContent =
      remainingTime.minutes;
    document.querySelector(".countdown__seconds").textContent =
      remainingTime.seconds;
  }
}

const dateElement = document.querySelector(".countdown");
if (dateElement) {
  const timer = new Timer(dateElement.dataset.date);
  timer.start();
}
